module.exports = __webpack_public_path__ + "img/ic_afpk.e930f521.svg";